import axios from '@/helpers/axios'

export default {
  /**
   * 更新状态
   *
   * @param {object} params 参数
   * @param {Array} params.ids 更新的记录
   * @param {string} params.status 更新的属性
   * @returns {Promise<object>} 空body
   */
  updateResolvedStatus(params) {
    return axios.put(`/backend/v2/alarms/resolved`, params)
  },
  /**
   * 报警查询列表
   *
   * @param {object} params 参数
   * @returns {Promise<object>} 格式 { total_count: 0, ... }
   */
  getAlarms(params) {
    return axios.get(`/backend/v2/alarms`, { params: params })
  },
  /**
   * 获取指定报警信息
   *
   * @param {object} id 参数
   * @returns {Promise<object>} 格式 { total_count: 0, ... }
   */
  getAlarm(id) {
    return axios.get(`/backend/v2/alarms/${id}`)
  },
  /**
   * 统计信息
   *
   * @param {object} params 参数
   * @returns {Promise<object>} 格式 { }
   */
  getSummary(params) {
    return axios.get('/backend/v2/alarms/summary', { params })
  }
}
